import { render, staticRenderFns } from "./ShelfDepthPicker.vue?vue&type=template&id=ceb61980&scoped=true"
import script from "./ShelfDepthPicker.vue?vue&type=script&lang=js"
export * from "./ShelfDepthPicker.vue?vue&type=script&lang=js"
import style0 from "./ShelfDepthPicker.vue?vue&type=style&index=0&id=ceb61980&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb61980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ceb61980')) {
      api.createRecord('ceb61980', component.options)
    } else {
      api.reload('ceb61980', component.options)
    }
    module.hot.accept("./ShelfDepthPicker.vue?vue&type=template&id=ceb61980&scoped=true", function () {
      api.rerender('ceb61980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/ShelfDepthPicker.vue"
export default component.exports